import script from "./MerchantAccounts.vue?vue&type=script&setup=true&lang=js"
export * from "./MerchantAccounts.vue?vue&type=script&setup=true&lang=js"

import "./MerchantAccounts.vue?vue&type=style&index=0&id=6d443c52&lang=scss&scoped=true"
import "./MerchantAccounts.vue?vue&type=style&index=1&id=6d443c52&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d443c52"]])

export default __exports__